import { Pipe, PipeTransform, inject } from '@angular/core';
import {DomSanitizer} from "@angular/platform-browser";

@Pipe({
  name: 'toSafeHtml',
  standalone: true
})
export class ToSafeHtmlPipe implements PipeTransform {
  private sanitizer = inject(DomSanitizer);

  transform(htmlText: string): any {
    return this.sanitizer.bypassSecurityTrustHtml(htmlText);
  }
}
